<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_(screen.menuTitle)" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>

		<template v-slot:content>
			<repay-mst-content ref="content" :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/RepayMst/store/helpers';
import RepayMstContent from './Content/RepayMstContent.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		console.clear();
		//진입시 초기화
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {
		RepayMstContent
	},
	data() {
		return {
			title: '클레임 변제결과',
			favorite: true,
			screen: {}
			// locations: ['시스템관리', '다국어/메시지 관리']
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
